import React, {useEffect, useState} from "react";
import {changeStatus, confirmReception, getById, update} from "../../services/service-order.service";
import {NavigateFunction, useNavigate, useParams} from "react-router-dom";
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {Chip as ChipMaterial, Link, TextField} from "@mui/material";
import {ArrowBackIosNew} from "@mui/icons-material";
import showNotification from "../utils/Notify";
import {Box, Breadcrumbs, Button, Grid, Stack, Tab, TabList, TabPanel, Tabs, Typography} from "@mui/joy";
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import IServiceOrder from "../../types/service-order.type";
import {Autocomplete} from "@mui/lab";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment, {Moment} from "moment/moment";
import IClient from "../../types/client.type";
import {getActiveClients} from "../../services/client.service";
import IUser from "../../types/user.type";
import ITechnique from "../../types/technique.type";
import {getActiveTechniques} from "../../services/techique.service";
import {getAllActiveByDepartment} from "../../services/user.service";
import IServiceOrderChangeStatus from "../../types/service-order-change-status.type";
import {Department} from "../../types/enumeration/Department";
import {ServiceOrderStatus} from "../../types/enumeration/ServiceOrderStatus";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import {ServiceOrderStatusColors} from "../../types/enumeration/ServiceOrderStatusColors";
import {ServiceOrderStatusNames} from "../../types/enumeration/ServiceOrderStatusNames";
import StatusHistoryModal from "../utils/StatusHistoryModal";
import ConfirmationModal from "../utils/ConfirmationModal";
import AllocatedResourcesList from "../serviceOrders/allocatedResource/AllocatedResourcesList";
import BudgetsList from "../serviceOrders/budget/BudgetsList";
import WorkScopesList from "../serviceOrders/workScope/WorkScopesList";
import WorkContactsList from "../serviceOrders/workContact/WorkContactsList";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import * as AuthService from "../../services/auth.service";
import IAllocatedResource from "../../types/allocated-resource.type";
import AttachmentsList from "../serviceOrders/attachments/AttachmentsList";
import IProvider from "../../types/provider.type";
import {getActiveSubcontractors} from "../../services/provider.service";
import {WorkPosition} from "../../types/enumeration/WorkPosition";
import {GridSaveAltIcon} from "@mui/x-data-grid";
import IWorkScope from "../../types/work-scope.type";

const MyServiceOrderForm = () => {
  let navigate: NavigateFunction = useNavigate();
  const { id } = useParams();
  const [clients, setClients] = useState<Array<IClient>>([]);
  const [users, setUsers] = useState<Array<IUser>>([]);
  const [resources, setResources] = useState<Array<IUser>>([]);
  const [techniques, setTechniques] = useState<Array<ITechnique>>([]);
  const [providers, setProviders] = useState<Array<IProvider>>([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const [statusHistoryModalOpen, setStatusHistoryModalOpen] = React.useState(false);
  const [selectedNewStatus, setSelectedNewStatus] = React.useState<ServiceOrderStatus | null>(null);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalMessage, setModalMessage] = React.useState("");
  const [currentUser, setCurrentUser] = useState<IUser | undefined>(undefined);
  const [userConfirmed, setUserConfirmed] = useState<boolean>(false);
  const [allowDefineWorkScope, setAllowDefineWorkScope] = useState<boolean>(false);

  const onConfirm = (comments?: string) => {
    if (selectedNewStatus) {
      let newStatus: IServiceOrderChangeStatus = {
        status: selectedNewStatus,
        comments: comments ? comments : '',
      };
      changeStatus(serviceOrder.id, newStatus)
        .then((response) => {
          let message = newStatus.status === ServiceOrderStatus.SENT ? "La Orden de Servicio fue Enviada correctamente."
            : "La Orden de Servicio fue Completada correctamente.";
          showNotification({type: 'success', message: message});
          goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    } else {
      confirmReception(serviceOrder.id)
        .then((response) => {
          showNotification({type: 'success', message: "La Orden de Servicio fue Recepcionada correctamente."});
          fetchServiceOrder();
        }).catch(error => {
        showNotification({type: 'error', message: error.response.data.message});
      });

    }

    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  };

  const handleConfirmationModalClose = () => {
    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  }

  const handleOpenChangeStatusModal = (status: ServiceOrderStatus | null) => {
    if (status == null) {
      setModalTitle("Confirmar Recepcion de la Orden de Servicio");
      setModalMessage("Al confirmar se Registrara la Recepcion de la Orden de Servicio y se habilitara la edicion de la misma.")
    } else if (status === ServiceOrderStatus.CONFIRM) {
      setModalTitle("Confirmar Orden de Servicio");
      setModalMessage("Al confirmar se Confirmara la Orden de Servicio.")
    } else if (status === ServiceOrderStatus.VALIDATE_WORK_SCOPE) {
      setModalTitle("Validar Alcance de Trabajo");
      setModalMessage("Al confirmar se enviada a validar el Alcance de Trabajo.")
    } else {
      setModalTitle("Completar Orden de Servicio");
      setModalMessage("Al confirmar se Marcara la Orden de Servicio como Completada.")
    }
    setSelectedNewStatus(status);
    setConfirmationModalOpen(true);
  };

  const handleStatusHistoryModalOpen = () => {
    setStatusHistoryModalOpen(true);
  }

  const handleStatusHistoryModalClose = () => {
    setStatusHistoryModalOpen(false);
  }

  const initialValues: IServiceOrder = {
    id: null,
    allocatedDays: 0,
    client: null,
    number: "",
    purchaseNumber: "",
    quoteNumber: "",
    start: null,
    workAddress: "",
    status: ServiceOrderStatus.IN_PROGRESS,
    statusHistory: [],
    workScopes: [],
    budgets: [],
    allocatedResources: [],
    workContacts: [],
    attachments: [],
  };

  const [serviceOrder, setServiceOrder] = useState<IServiceOrder>(initialValues);

  const updateServiceOrder = async (
    updatedServiceOrder: IServiceOrder | ((prev: IServiceOrder) => IServiceOrder)
  ) => {
    const newServiceOrder =
      typeof updatedServiceOrder === "function" ? updatedServiceOrder(serviceOrder) : updatedServiceOrder;

    setServiceOrder(newServiceOrder);
    await formik.setValues(newServiceOrder);

    const workers: IUser[] = newServiceOrder.allocatedResources
      .map(resource => resource.worker)
      .filter((worker): worker is IUser => worker !== null);

    setResources(workers);

    const serviceOrderToSave = cleanWorkScopes(newServiceOrder);

    if (serviceOrderToSave.id) {
      update(serviceOrderToSave.id, serviceOrderToSave)
        .then(() => {
          showNotification({
            type: 'success',
            message: 'Orden de Servicio guardada correctamente.',
          });
        })
        .catch(error => {
          showNotification({
            type: 'error',
            message: error.response.data.message,
          });
        });
    }
  };

  const validationSchema = Yup.object({
    client: Yup.object().required('El Cliente es requerido'),
    workAddress: Yup.string().required('La Direccion de Obra es requerido'),
    number: Yup.string().required('El Nro. de Orden de Servicio es requerido'),
    purchaseNumber: Yup.string().required('El Nro. de Orden de Compra es requerido'),
    quoteNumber: Yup.string().required('El Nro. de Cotizacion es requerido'),
    start: Yup.string().required('La Fecha de Inicio es requerido'),
    allocatedDays: Yup.string().required('Las Jornadas Asignadas es requerido'),
  });

  function isUUID(value: any): boolean {
    return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  }

  function normalizeWorkScope(workScope: IWorkScope & { technique?: unknown }): IWorkScope {
    const { technique, ...rest } = workScope;

    return {
      ...rest,
      id: isUUID(rest.id) ? undefined : rest.id,
      techniques: rest.techniques?.length
        ? rest.techniques
        : technique
          ? [technique as ITechnique]
          : [],
    };
  }

  function cleanWorkScopes(serviceOrder: IServiceOrder): IServiceOrder {
    return {
      ...serviceOrder,
      workScopes: serviceOrder.workScopes.map(ws => normalizeWorkScope(ws)),
    };
  }

  const onSubmit = (serviceOrder: IServiceOrder) => {
    serviceOrder = cleanWorkScopes(serviceOrder);
    update(serviceOrder.id, serviceOrder)
      .then(() => {
        showNotification({type: 'success', message: 'Orden de Servicio actualizada correctamente.'});
        fetchServiceOrder();
      })
      .catch(error => {
        showNotification({type: 'error', message: error.response.data.message});
      });
  };

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  const goBack = () => {
    navigate(-1)
  };

  const handleChangeStartDate = (value: Moment | null) => {
    formik.setFieldValue('start', moment(value).format('YYYY-MM-DDThh:mm:ss'))
  };

  const fetchServiceOrder = async () => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }

    const workOrderResponse = await getById(id);
    const normalizedServiceOrder = {
      ...workOrderResponse.data,
      workScopes: (workOrderResponse.data.workScopes || []).map((ws: IWorkScope & { technique?: unknown }) => normalizeWorkScope(ws)),
    };

    setServiceOrder(normalizedServiceOrder)
    await formik.setValues(normalizedServiceOrder);
    await formik.setFieldValue('start', moment(normalizedServiceOrder.start))
    const workers: IUser[] = workOrderResponse.data.allocatedResources
      .map((resource: any) => resource.worker)
      .filter((worker: any): worker is IUser => worker !== null);
    setResources(workers);

    const match = (workOrderResponse.data.allocatedResources as IAllocatedResource[])
      .find((ar: IAllocatedResource) => ar.worker?.id === user?.id);

    setUserConfirmed(match ? match.confirmed : false)

    if (
      (workOrderResponse.data.status === ServiceOrderStatus.DEFINE_WORK_SCOPE || workOrderResponse.data.status === ServiceOrderStatus.FIX_WORK_SCOPE)
      && match?.workPosition === WorkPosition.TECHNICAL_ANALYST
      && match?.confirmed === true
    ) {
      setAllowDefineWorkScope(true);
    }
  };

  const fetchClients = async () => {
    getActiveClients().then( (response) => {
      setClients(response.data)
    })
  };

  const fetchUsers = async () => {
    getAllActiveByDepartment(Department.OPERATOR).then( (response) => {
      setUsers(response.data)
    })
  };

  const fetchTechniques = async () => {
    const techniquesResponse = await getActiveTechniques();
    setTechniques(techniquesResponse.data);
  };

  const fetchProviders = async () => {
    const providersResponse = await getActiveSubcontractors();
    setProviders(providersResponse.data);
  };

  useEffect(() => {
    fetchClients();
    fetchTechniques();
    fetchUsers();
    fetchProviders();
  }, []);

  useEffect(() => {
    fetchServiceOrder()
  }, [ id ])

  return (
    <Box
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: { xs: 1 },
              width: '100%',
            }}
          >
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon/>}
              sx={{ pl: 0 }}
            >
              <Typography level="h4" component="h1">
                <DesignServicesIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
              </Typography>
              <Typography level="h4" component="h1">
                <Link
                  underline={"none"}
                  onClick={() => goBack()}
                  sx={{ cursor: 'pointer' }}
                >
                  Ordenes de Servicio
                </Link>
              </Typography>
              <Typography level="h4" component="h1">
                {id ? "Editar" : "Nuevo"}
              </Typography>
            </Breadcrumbs>
            <Box>
              <CssVarsProvider>
                <ChipMaterial
                  color={ServiceOrderStatusColors[ServiceOrderStatus[formik.values.status as keyof typeof ServiceOrderStatus]]}
                  label={ServiceOrderStatusNames[ServiceOrderStatus[formik.values.status as keyof typeof ServiceOrderStatus]]}
                  sx={{width: 200, fontWeight: 'bold', fontSize: 15}}
                  icon={<ManageSearchIcon fontSize="medium" sx={{marginTop: -0.5}} />}
                  clickable={true}
                  onClick={() => handleStatusHistoryModalOpen()}
                />
              </CssVarsProvider>
            </Box>
          </Box>

          <ConfirmationModal
            open={confirmationModalOpen}
            onConfirm={(comments?: string) => { onConfirm(comments)}}
            onCancel={handleConfirmationModalClose}
            title={modalTitle}
            message={modalMessage}
            isDeleteAction={false}
            enableComments={true}
          />

          <StatusHistoryModal
            open={statusHistoryModalOpen}
            title={"Historial de la Orden de Servicio"}
            history={serviceOrder.statusHistory}
            onCancel={handleStatusHistoryModalClose}
            historyType={"serviceOrder"}
          />

          <Box sx={{ width: '100%', typography: 'body1' }}>
            <form className="form" onSubmit={formik.handleSubmit}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={2}
                marginBlock={1}
                marginInline={0}
                sx={{ width: '100%' }}
              >
                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="number"
                      label="Numero Orden de Servicio"
                      name="number"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.number}
                      error={!!(formik.touched.number && formik.errors.number)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.number && formik.errors.number ? (
                      <span className="Error-alert">{formik.errors.number}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <Autocomplete
                      id="client"
                      value={formik.values.client}
                      getOptionLabel={(client) =>
                        `${client.name || ''} - CUIT: ${client.cuit || '...'}`
                      }
                      options={clients}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, value) => {
                        formik.setFieldValue('client', value);
                      }}
                      fullWidth
                      readOnly={true}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant={"filled"}
                          name="client"
                          label="Cliente"
                          slotProps={{ inputLabel: {shrink: true}}}
                          onBlur={formik.handleBlur}
                          error={!!(formik.touched.client && formik.errors.client)}
                        />
                      )}
                    />
                    {formik.touched.client && formik.errors.client ? (
                      <span className="Error-alert">{String(formik.errors.client)}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="quoteNumber"
                      label="Numero de Cotizacion"
                      name="quoteNumber"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.quoteNumber}
                      error={!!(formik.touched.quoteNumber && formik.errors.quoteNumber)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.quoteNumber && formik.errors.quoteNumber ? (
                      <span className="Error-alert">{formik.errors.quoteNumber}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="purchaseNumber"
                      label="Numero Orden de Compra"
                      name="purchaseNumber"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.purchaseNumber}
                      error={!!(formik.touched.purchaseNumber && formik.errors.purchaseNumber)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.purchaseNumber && formik.errors.purchaseNumber ? (
                      <span className="Error-alert">{formik.errors.purchaseNumber}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="workAddress"
                      label="Direccion de Obra"
                      name="workAddress"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.workAddress}
                      error={!!(formik.touched.workAddress && formik.errors.workAddress)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.workAddress && formik.errors.workAddress ? (
                      <span className="Error-alert">{formik.errors.workAddress}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        name="start"
                        label="Fecha de inicio"
                        format="DD/MM/YYYY"
                        value={formik.values.start ? moment(formik.values.start) : null }
                        onChange={handleChangeStartDate}
                        readOnly={true}
                        slotProps={{
                          textField: {
                            variant: 'filled',
                            fullWidth: true,
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            error: formik.touched.start && Boolean(formik.errors.start),
                            InputLabelProps: {
                              shrink:  true
                            }
                          }
                        }} />
                    </LocalizationProvider>
                    {formik.touched.start && formik.errors.start ? (
                      <span className="Error-alert">{formik.errors.start}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="allocatedDays"
                      label="Jornadas Asignadas"
                      name="allocatedDays"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.allocatedDays}
                      error={!!(formik.touched.allocatedDays && formik.errors.allocatedDays)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.allocatedDays && formik.errors.allocatedDays ? (
                      <span className="Error-alert">{formik.errors.allocatedDays}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

              </Grid>

              <Box sx={{ width: '100%', height: 438, typography: 'body1' }} ml={1} mt={2} pr={2}>
                <Tabs defaultValue={0}>
                  <TabList>
                    <Tab value={0}>Recursos Asignados</Tab>
                    <Tab value={1}>Alcance del Trabajo</Tab>
                    <Tab value={2}>Presupuesto</Tab>
                    <Tab value={3}>Contactos de Obra</Tab>
                    <Tab value={4}>Documentacion Adjunta</Tab>
                  </TabList>
                  <TabPanel value={0} sx={{padding: 0}}>
                    <AllocatedResourcesList
                      serviceOrder={serviceOrder}
                      setServiceOrder={updateServiceOrder}
                      users={users}
                      readOnly={true}
                    />
                  </TabPanel>
                  <TabPanel value={1} sx={{padding: 0}}>
                    <WorkScopesList
                      serviceOrder={serviceOrder}
                      setServiceOrder={updateServiceOrder}
                      techniques={techniques}
                      users={resources}
                      readOnly={!allowDefineWorkScope}
                    />
                  </TabPanel>
                  <TabPanel value={2} sx={{padding: 0}}>
                    <BudgetsList
                      serviceOrder={serviceOrder}
                      setServiceOrder={updateServiceOrder}
                      users={resources}
                      providers={providers}
                      readOnly={true}
                    />
                  </TabPanel>
                  <TabPanel value={3} sx={{padding: 0}}>
                    <WorkContactsList
                      serviceOrder={serviceOrder}
                      setServiceOrder={updateServiceOrder}
                      readOnly={true}
                    />
                  </TabPanel>
                  <TabPanel value={4} sx={{padding: 0}}>
                    <AttachmentsList
                      serviceOrder={serviceOrder}
                      setServiceOrder={updateServiceOrder}
                      readOnly={false}
                    />
                  </TabPanel>
                </Tabs>
              </Box>

              <Stack direction="row" justifyContent="space-between" spacing={2} pr={1} pl={1}>
                <Stack direction="row" justifyContent="flex-start" spacing={2}>
                  {id && (formik.values.status === ServiceOrderStatus.DEFINE_WORK_SCOPE || formik.values.status === ServiceOrderStatus.FIX_WORK_SCOPE) && userConfirmed &&
                    <Button
                        onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.VALIDATE_WORK_SCOPE)}
                        variant="solid"
                        color="neutral"
                        endDecorator={<CheckCircleIcon />}
                    >
                        Validar Alcance de Trabajo
                    </Button>
                  }

                  {id && formik.values.status === ServiceOrderStatus.SENT && userConfirmed &&
                    <Button
                        onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.CONFIRM)}
                        variant="solid"
                        color="primary"
                        endDecorator={<CheckCircleIcon />}
                    >
                        Confirmar Orden de Servicio
                    </Button>
                  }
                  {id && formik.values.status === ServiceOrderStatus.SENT && !userConfirmed &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(null)}
                          variant="solid"
                          color="primary"
                          endDecorator={<CheckCircleIcon />}
                      >
                          Confirmar Recepcion
                      </Button>
                  }
                  {id && formik.values.status === ServiceOrderStatus.DEFINE_WORK_SCOPE && !userConfirmed &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(null)}
                          variant="solid"
                          color="primary"
                          endDecorator={<CheckCircleIcon />}
                      >
                          Confirmar Recepcion
                      </Button>
                  }
                  {id && (formik.values.status === ServiceOrderStatus.CONFIRM || formik.values.status === ServiceOrderStatus.TO_FIX) &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.COMPLETED)}
                          variant="solid"
                          color="success"
                          endDecorator={<CheckCircleIcon />}
                      >
                          Completar Orden de Servicio
                      </Button>
                  }
                </Stack>
                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                  <Button onClick={() => goBack()} variant="outlined" endDecorator={<ArrowBackIosNew />}>Volver</Button>
                  {/*{allowDefineWorkScope &&*/}
                  {/*    <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>*/}
                  {/*}*/}
                </Stack>

              </Stack>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyServiceOrderForm;
